var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { EntityLink } from './entity-link';
import relativeDate from 'tiny-relative-date';
import { ContentNode } from './content-node';
import { IconButton } from '../elements/icon-button';
import { useLang } from '../hooks/use-lang';
import { BinIconGlyph, PenIcon } from '@shapeable/icons';
import { EntityBubbleImage } from './entity-bubble-image';
export var CommentDefaultProps = {
  isReply: false,
  showEditControls: true
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    font-size: ", ";\n  "], ["\n    display: flex;\n    font-size: ", ";\n  "])), theme.FONT_SIZE(14)),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "]))),
  desktop: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme.FONT_SIZE(15))
});
var AvatarStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-right: ", ";\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: column;\n    align-self: flex-start;\n  "], ["\n    margin-right: ", ";\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: column;\n    align-self: flex-start;\n  "])), theme.UNIT(3))
});
var BodyStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject([" \n    flex-grow: 1;\n    margin: 0;\n  "], [" \n    flex-grow: 1;\n    margin: 0;\n  "])))
});
var CreatorStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    color: ", ";\n    font-weight: 600;\n    font-size: 1em;\n  "], ["\n    color: ", ";\n    font-weight: 600;\n    font-size: 1em;\n  "])), theme.COLOR('text'))
});
var SourceItemStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    white-space: nowrap;\n    margin-left: ", ";\n  "], ["\n    white-space: nowrap;\n    margin-left: ", ";\n  "])), theme.UNIT(1)),
  tablet: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    margin-left: ", ";\n\n    &:before {\n      content: '\u2022';\n      color: ", ";\n      margin-right: ", ";\n    }\n  "], ["\n    margin-left: ", ";\n\n    &:before {\n      content: '\u2022';\n      color: ", ";\n      margin-right: ", ";\n    }\n  "])), theme.UNIT(2), theme.COLOR('text-subtle'), theme.UNIT(2))
});
var WhenStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    color: ", ";\n    \n    ", ";\n  "], ["\n    color: ", ";\n    \n    ", ";\n  "])), theme.COLOR('text-subtle'), SourceItemStyles)
});
var OrganisationStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    color: ", ";\n    display: none;\n    font-size: 1em;\n    ", ";\n  "], ["\n    color: ", ";\n    display: none;\n    font-size: 1em;\n    ", ";\n  "])), theme.COLOR("text-subtle"), SourceItemStyles),
  tablet: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    display: inline-block;\n  "], ["\n    display: inline-block;\n  "])))
});
var SourceStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    margin: 0 0 ", " 0;\n    display: flex;\n    flex-wrap: wrap;\n    font-size: 1em;\n  "], ["\n    margin: 0 0 ", " 0;\n    display: flex;\n    flex-wrap: wrap;\n    font-size: 1em;\n  "])), theme.UNIT(1)),
  tablet: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    margin: 0 0 ", " 0;\n  "], ["\n    margin: 0 0 ", " 0;\n  "])), theme.UNIT(1.5))
});
var CommentStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    line-height: 1.5em;\n\n    p {\n      margin-top: 0; \n    }\n  "], ["\n    line-height: 1.5em;\n\n    p {\n      margin-top: 0; \n    }\n  "])))
});
var ButtonStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    text-transform: none;\n    font-size: 1em;\n  "], ["\n    text-transform: none;\n    font-size: 1em;\n  "])))
});
var EditButtonStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    ", ";\n    ", ";\n  "], ["\n    ", ";\n    ", ";\n  "])), SourceItemStyles, ButtonStyles)
});
var DeleteButtonStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    ", ";\n    ", ";\n    &:before {\n      content: '\u2022';\n      color: ", ";\n      margin-right: ", ";\n    }\n  "], ["\n    ", ";\n    ", ";\n    &:before {\n      content: '\u2022';\n      color: ", ";\n      margin-right: ", ";\n    }\n  "])), SourceItemStyles, ButtonStyles, theme.COLOR('text-subtle'), theme.UNIT(1)),
  tablet: css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    &:before {\n      margin-right: ", ";\n    }\n  "], ["\n    &:before {\n      margin-right: ", ";\n    }\n  "])), theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Avatar: styled(EntityBubbleImage)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), AvatarStyles),
  Body: styled.article(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Source: styled.header(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), SourceStyles),
  Organisation: styled(EntityLink)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), OrganisationStyles),
  Creator: styled(EntityLink)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), CreatorStyles),
  When: styled.time(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), WhenStyles),
  EditButton: styled(IconButton)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), EditButtonStyles),
  DeleteButton: styled(IconButton)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), DeleteButtonStyles),
  Comment: styled(ContentNode)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), CommentStyles)
};
export var Comment = function (props) {
  var className = props.className,
    entity = props.entity,
    isReply = props.isReply,
    onEdit = props.onEdit,
    onDelete = props.onDelete,
    canDelete = props.canDelete,
    canEdit = props.canEdit,
    showEditControls = props.showEditControls;
  var avatarSize = isReply ? 36 : 48;
  var t = useLang();
  var createdBy = entity.createdBy,
    created = entity.created,
    description = entity.description,
    isWriteable = entity.isWriteable;
  var organisation = (createdBy || {}).organisation;
  // TO-DO - Add isWriteable to the list of conditions to display editButton and DeleteButton
  return React.createElement(My.Container, {
    className: className
  }, React.createElement(My.Avatar, {
    size: avatarSize,
    entity: createdBy,
    showBorder: true
  }), React.createElement(My.Body, null, React.createElement(My.Source, null, React.createElement(My.Creator, {
    entity: createdBy
  }), organisation && React.createElement(My.Organisation, {
    entity: organisation
  }), React.createElement(My.When, {
    datetime: created
  }, relativeDate(created)), showEditControls && isWriteable && canEdit && React.createElement(My.EditButton, {
    onClick: onEdit,
    iconSize: 15,
    icon: React.createElement(PenIcon, null)
  }, t('Edit')), showEditControls && isWriteable && canDelete && React.createElement(My.DeleteButton, {
    onClick: onDelete,
    iconSize: 15,
    icon: React.createElement(BinIconGlyph, null)
  }, t('Delete'))), React.createElement(My.Comment
  // showEmbeds 
  // entityTypeNameEmbedExclusions={["Person", "Team"]} 
  , {
    // showEmbeds 
    // entityTypeNameEmbedExclusions={["Person", "Team"]} 
    entity: description
  })));
};
Comment.defaultProps = CommentDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28;